<template>
  <Layout>
    <FetchJson url="filter-data/applications">
      <template #default="{ json: filterData, loading }">
        <template v-if="!loading">
          <FilterPanel
            :modelValue="filter"
            :filterData="filterData"
            @update:modelValue="setFilter"
          />
          <div class="layout--horizontal layout--alignment-flex-start">
            <ApplicationtSendMethodIndicator :filter="filter" />
            <ApplicationtSendMethodDailyAverageIndicator :filter="filter" />
          </div>
          <template v-if="!filter.territory.alias">
            <ApplicationtSendMethodChart
              :filter="filter"
              :applicationKinds="
                filteredApplicationKinds(filterData.applicationKinds)
              "
              @update:applicationKind="setFilter"
            />
            <ApplicationtSendMethodTable :filter="filter" />
          </template>
          <template v-else>
            <ApplicationtSendMethodTable :filter="filter" />
          </template>
        </template>
        <FilterPanelSkeleton v-else></FilterPanelSkeleton>
      </template>
    </FetchJson>
  </Layout>
</template>

<script>
import useApplicationsFilter from "@/components/applications/filter";
import Layout from "./Layout";
import FilterPanel from "@/components/common/FilterPanel2";
import FilterPanelSkeleton from "@/components/common/FilterPanelSkeleton";
import ApplicationtSendMethodIndicator from "@/components/applications/ApplicationtSendMethodIndicator";
import ApplicationtSendMethodDailyAverageIndicator from "@/components/applications/ApplicationtSendMethodDailyAverageIndicator";
import ApplicationtSendMethodChart from "@/components/applications/ApplicationtSendMethodChart";
import ApplicationtSendMethodTable from "@/components/applications/ApplicationtSendMethodTable";

export default {
  components: {
    Layout,
    FilterPanel,
    FilterPanelSkeleton,
    ApplicationtSendMethodIndicator,
    ApplicationtSendMethodDailyAverageIndicator,
    ApplicationtSendMethodChart,
    ApplicationtSendMethodTable,
  },
  setup() {
    const { filter, setFilter } = useApplicationsFilter();

    const filteredApplicationKinds = function (applicationKinds) {
      const map = new Map();
      const res = [];
      applicationKinds.forEach((apk) => {
        if (!map.has(apk.alias)) {
          map.set(apk.alias);
          res.push(apk);
        }
      });

      return res;
    };

    return {
      filter,
      setFilter,
      filteredApplicationKinds,
    };
  },
};
</script>
